import { ReactNode, useState } from 'react'
import { Switch as AriaSwitch, SwitchProps } from 'react-aria-components'

type Props = SwitchProps & {
	label?: ReactNode
	labelBefore?: ReactNode
}

const toBoolean = (value: number | string | boolean | undefined) => {
	if (value === undefined || typeof value === 'boolean') return value
	return value === '1' || value === 1
}

export function Switch({
	label,
	labelBefore,
	isSelected,
	defaultSelected,
	onChange,
	...props
}: Props) {
	const [checked, setChecked] = useState(toBoolean(isSelected) || toBoolean(defaultSelected))
	return (
		<>
			{checked ? null : <input type="hidden" name={props.name} value="0" />}
			<AriaSwitch
				className="group flex gap-2 items-center"
				value="1"
				isSelected={toBoolean(isSelected)}
				defaultSelected={toBoolean(defaultSelected)}
				onChange={isSelected => {
					setChecked(isSelected)
					onChange?.(isSelected)
				}}
				{...props}
			>
				{labelBefore && (
					<div className="flex font-normal leading-tight text-gray-700 text-sm">
						{labelBefore}
					</div>
				)}
				<div className="flex h-[22px] w-[36px] shrink-0 cursor-default rounded-full shadow-inner bg-clip-padding border border-solid border-white/30 p-[3px] box-border transition duration-200 ease-in-out bg-gray-300 group-pressed:bg-gray-500 group-selected:bg-blue-600 group-selected:group-pressed:bg-blue-800 outline-none group-focus-visible:ring-2 ring-black">
					<span className="h-[14px] w-[14px] transform rounded-full bg-white shadow transition duration-200 ease-in-out translate-x-0 group-selected:translate-x-[100%]" />
				</div>
				{label && (
					<div className="flex font-normal leading-tight text-gray-700 text-sm">
						{label}
					</div>
				)}
			</AriaSwitch>
		</>
	)
}
